export const pagesEn: Record<string, string> = {
  "界面语言": "Interface language",
  "默认跟随系统，切换后立即生效，不会清空正在填写的内容。": "Follows your system by default. Changes apply immediately without clearing your input.",
  "{{p0}} 个待上传": "{{p0}} pending uploads",
  "{{p0}} 个有效下载分享 · {{p1}} 个有效上传链接": "{{p0}} active download shares · {{p1}} active upload links",
  "自定义 S3 兼容": "Custom S3-compatible",
  "https://api.telegram.org（可选，留空使用默认）": "https://api.telegram.org (optional; leave blank for default)",
  "从 @BotFather 获取，格式：<id>:<token>": "Get this from @BotFather; format: <id>:<token>",
  "单文件上传上限 {{p0}}（Telegram Bot API 限制）": "Maximum file upload size: {{p0}} (Telegram Bot API limit)",
  "请确保 Bot 已被添加为目标频道/群组的管理员": "Make sure the bot is added to the target channel/group as an administrator",
  "私人频道 Chat ID 通常以 {{p0}} 开头": "Private channel chat IDs usually start with {{p0}}",
  "{{p0}}，{{p1}}": "{{p0}}, {{p1}}",
  "需要管理员权限": "Administrator access required",
  "您没有权限访问此页面": "You do not have permission to access this page",
  "用户管理": "Users",
  "注册控制": "Registration",
  "邮件配置": "Email configuration",
  "审计日志": "Audit log",
  "系统统计": "System statistics",
  "管理员面板": "Admin panel",
  "系统管理与配置": "System administration and configuration",
  "用户已更新": "User updated",
  "更新失败": "Update failed",
  "用户已删除": "User deleted",
  "删除失败": "Deletion failed",
  "用户列表": "User list",
  "管理系统中的所有用户": "Manage all users in the system",
  "暂无用户": "No users yet",
  "昵称": "Nickname",
  "显示名称": "Display name",
  "角色": "Role",
  "普通用户": "User",
  "管理员": "Administrator",
  "存储配额 (GB)": "Storage quota (GB)",
  "留空则不限制": "Leave blank for no limit",
  "新密码": "New password",
  "留空则不修改": "Leave blank to keep unchanged",
  "保存": "Save",
  "取消": "Cancel",
  "无限制": "Unlimited",
  "{{p0}} 文件": "{{p0}} files",
  "确认删除用户": "Confirm user deletion",
  "此操作将永久删除该用户及其所有数据，且不可恢复。": "This permanently deletes the user and all their data. This action cannot be undone.",
  "确认删除": "Confirm deletion",
  "设置已更新": "Settings updated",
  "已生成 {{p0}} 个邀请码": "Generated {{p0}} invitation codes",
  "生成失败": "Generation failed",
  "邀请码已撤销": "Invitation code revoked",
  "撤销失败": "Revocation failed",
  "已复制邀请码": "Invitation code copied",
  "管理用户注册方式和邀请码": "Manage registration and invitation codes",
  "开放注册": "Open registration",
  "允许新用户注册账号": "Allow new users to register",
  "已开放": "Open",
  "已关闭": "Closed",
  "需要邀请码": "Require invitation code",
  "注册时必须提供有效邀请码": "A valid invitation code is required to register",
  "已启用": "Enabled",
  "已禁用": "Disabled",
  "邀请码管理": "Invitation codes",
  "生成和管理注册邀请码": "Generate and manage registration invitation codes",
  "生成": "Generate",
  "暂无邀请码": "No invitation codes yet",
  "已使用": "Used",
  "未使用": "Unused",
  "用户总数": "Total users",
  "文件总数": "Total files",
  "文件夹": "Folder",
  "存储桶": "Bucket",
  "总存储用量": "Total storage used",
  "存储厂商分布": "Storage providers",
  "各存储厂商的使用情况": "Usage by storage provider",
  "{{p0}} 个存储桶": "{{p0}} buckets",
  "全部操作": "All actions",
  "登录": "Sign in",
  "登出": "Sign out",
  "注册": "Register",
  "更新用户": "Update user",
  "删除用户": "Delete user",
  "文件上传": "File upload",
  "文件下载": "File download",
  "文件删除": "File deletion",
  "文件移动": "File move",
  "文件重命名": "File rename",
  "创建文件夹": "Create folder",
  "创建分享": "Create share",
  "访问分享": "Access share",
  "创建存储桶": "Create bucket",
  "更新存储桶": "Update bucket",
  "删除存储桶": "Delete bucket",
  "管理用户": "Manage users",
  "配置变更": "Configuration change",
  "生成邀请码": "Generate invitation code",
  "撤销邀请码": "Revoke invitation code",
  "上传": "Upload",
  "下载": "Download",
  "删除": "Delete",
  "移动": "Move",
  "重命名": "Rename",
  "系统操作记录": "System activity records",
  "暂无审计日志": "No audit logs yet",
  "上一页": "Previous",
  "下一页": "Next",
  "存储分析": "Storage analytics",
  "存储空间使用情况与文件活动统计": "Storage usage and file activity statistics",
  "请输入显示名称": "Enter a display name",
  "请输入 Bot Token": "Enter a bot token",
  "请输入 Chat ID": "Enter a chat ID",
  "请输入存储桶名称": "Enter a bucket name",
  "请输入 Access Key ID": "Enter an access key ID",
  "请输入 Secret Access Key": "Enter a secret access key",
  "该厂商需要填写区域": "A region is required for this provider",
  "存储厂商": "Storage provider",
  "如：我的 Telegram 频道": "e.g. My Telegram channel",
  "如：我的 R2 存储桶": "e.g. My R2 bucket",
  "频道/群组 ID，私人频道通常以 -100 开头": "Channel/group ID; private channel IDs usually start with -100",
  "存储桶名称": "Bucket name",
  "如：my-bucket-name": "e.g. my-bucket-name",
  "Telegram Bot 配置": "Telegram bot configuration",
  "留空则保留原有 Token": "Leave blank to keep the existing token",
  "从 @BotFather 获取，格式：&lt;id&gt;:&lt;token&gt;": "Get this from @BotFather; format: <id>:<token>",
  "Bot API 代理地址（可选）": "Bot API proxy URL (optional)",
  "https://api.telegram.org（留空使用默认）": "https://api.telegram.org (leave blank for default)",
  "仅在无法直连 Telegram 时填入自建代理": "Use a self-hosted proxy only when Telegram cannot be reached directly",
  "⚠️ 使用须知": "Usage notes",
  "单文件上传上限": "Maximum file upload size",
  "（Telegram Bot API 限制）": "(Telegram Bot API limit)",
  "请确保 Bot 已被添加为目标频道/群组的": "Make sure the bot is added to the target channel/group as an",
  "私人频道 Chat ID 通常以": "Private channel chat IDs usually start with",
  "存储空间由 Telegram 服务器提供，理论无上限": "Storage is provided by Telegram servers, with no theoretical limit",
  "留空使用默认": "Leave blank for default",
  "区域 (Region)": "Region",
  "选择区域…": "Select region...",
  "如：us-east-1（可选）": "e.g. us-east-1 (optional)",
  "访问凭证": "Access credentials",
  "（留空则保留原值）": "(leave blank to keep existing values)",
  "留空则保留原有凭证": "Leave blank to keep the existing credentials",
  "输入 Access Key ID": "Enter access key ID",
  "输入 Secret Access Key": "Enter secret access key",
  "强制 Path-style URL": "Force path-style URLs",
  "（MinIO / B2 等需要）": "(required by MinIO, B2, etc.)",
  "设为默认存储桶": "Set as default bucket",
  "备注（可选）": "Notes (optional)",
  "用途说明或备忘信息": "Purpose or other notes",
  "存储限额（可选）": "Storage limit (optional)",
  "限制此存储桶的最大使用量（留空则无限制）": "Limit the storage used by this bucket (leave blank for no limit)",
  "保存修改": "Save changes",
  "添加存储桶": "Add bucket",
  "默认": "Default",
  "{{p0}} 个文件": "{{p0}} files",
  "测试连接": "Test connection",
  "编辑": "Edit",
  "设为默认": "Set as default",
  "禁用": "Disable",
  "启用": "Enable",
  "将此存储桶的文件迁移到另一个存储桶": "Move files from this bucket to another bucket",
  "迁移文件": "Migrate files",
  "存储桶已添加": "Bucket added",
  "添加失败": "Failed to add",
  "存储桶已更新": "Bucket updated",
  "已删除存储桶": "Bucket deleted",
  "已设为默认存储桶": "Default bucket set",
  "操作失败": "Operation failed",
  "已启用存储桶": "Bucket enabled",
  "已禁用存储桶": "Bucket disabled",
  "✅ 连接成功": "Connection successful",
  "❌ 连接失败": "Connection failed",
  "测试失败": "Test failed",
  "存储桶管理": "Buckets",
  "管理多厂商、多存储桶的连接配置": "Manage connections to multiple providers and buckets",
  "安全限制：未经批准的自定义存储或机器人端点访问及连接测试已暂停。保存配置不代表目标已获批准，相关文件操作可能被服务端拒绝。": "Security restriction: access to unapproved custom storage or bot endpoints and connection tests is paused. Saving a configuration does not approve its destination; related file operations may be rejected by the server.",
  "编辑：{{p0}}": "Edit: {{p0}}",
  "添加新存储桶": "Add new bucket",
  "修改存储桶配置": "Edit bucket configuration",
  "配置 S3 兼容存储桶的连接信息": "Configure an S3-compatible bucket connection",
  "加载中…": "Loading...",
  "暂无存储桶配置": "No buckets configured yet",
  "添加第一个存储桶来开始管理您的对象存储": "Add your first bucket to start managing object storage",
  "添加第一个存储桶": "Add first bucket",
  "确认删除存储桶": "Confirm bucket deletion",
  "删除存储桶配置后，该存储桶中的文件记录仍会保留，但将无法通过此系统访问或操作这些文件。": "Deleting this bucket configuration keeps its file records, but these files will no longer be accessible or manageable through this system.",
  "支持的存储厂商": "Supported storage providers",
  "所有支持 S3 兼容 API 的对象存储服务均可通过\"自定义 S3 兼容\"接入。 凭证将加密存储于数据库中。": "Any object storage service with an S3-compatible API can be connected using \"Custom S3-compatible\". Credentials are encrypted in the database.",
  "图片": "Images",
  "视频": "Videos",
  "音频": "Audio",
  "文档": "Documents",
  "表格": "Spreadsheets",
  "演示": "Presentations",
  "压缩包": "Archives",
  "安装包": "Installers",
  "代码": "Code",
  "文本": "Text",
  "其他": "Other",
  "夜深了": "Good night",
  "早上好": "Good morning",
  "下午好": "Good afternoon",
  "晚上好": "Good evening",
  "这是您的文件存储概览": "Here is your file storage overview",
  "回收站": "Trash",
  "已用空间": "Storage used",
  "最近上传": "Recent uploads",
  "查看全部": "View all",
  "还没有上传任何文件": "No files uploaded yet",
  "存储空间": "Storage",
  "各存储桶用量": "Usage by bucket",
  "文件类型分布": "File types",
  "暂无数据": "No data yet",
  "等待中": "Queued",
  "下载中": "Downloading",
  "已暂停": "Paused",
  "已完成": "Completed",
  "失败": "Failed",
  "未知": "Unknown",
  "保存到文件夹（可选）": "Save to folder (optional)",
  "暂停": "Pause",
  "恢复": "Resume",
  "重试": "Retry",
  "根目录": "Root directory",
  "已选文件夹": "Selected folder",
  "下载任务已创建": "Download task created",
  "创建失败": "Creation failed",
  "批量导入完成：{{p0}} 成功，{{p1}} 失败": "Batch import complete: {{p0}} succeeded, {{p1}} failed",
  "批量导入失败": "Batch import failed",
  "任务已删除": "Task deleted",
  "任务已重试": "Task retried",
  "重试失败": "Retry failed",
  "恢复失败": "Resume failed",
  "已清理 {{p0}} 个已完成任务": "Cleared {{p0}} completed tasks",
  "已清理 {{p0}} 个失败任务": "Cleared {{p0}} failed tasks",
  "离线下载": "Offline downloads",
  "创建和管理离线下载任务": "Create and manage offline download tasks",
  "安全限制：任意 URL 离线下载已暂停，包括新建、批量导入、重试和恢复。现有任务记录仍可查看和删除。": "Security restriction: downloads from arbitrary URLs are paused, including creation, batch imports, retries, and resuming. Existing task records can still be viewed and deleted.",
  "刷新": "Refresh",
  "新建下载": "New download",
  "批量导入": "Batch import",
  "新建离线下载": "New offline download",
  "批量 URL 导入": "Batch URL import",
  "输入文件 URL 创建下载任务": "Enter a file URL to create a download task",
  "每行一条 URL，最多 50 条（当前 {{p0}} 条）": "One URL per line, up to 50 (currently {{p0}})",
  "单条": "Single",
  "批量": "Batch",
  "文件 URL": "File URL",
  "保存文件名（可选）": "Save as (optional)",
  "留空则使用原文件名": "Leave blank to use the original filename",
  "URL 列表（每行一条）": "URL list (one per line)",
  "存储桶（可选）": "Bucket (optional)",
  "默认存储桶": "Default bucket",
  "创建任务": "Create task",
  "导入": "Import",
  "{{p0}} 条": "{{p0}} URLs",
  "进行中的任务": "Active tasks",
  "{{p0}} 个任务正在处理": "{{p0}} tasks in progress",
  "失败的任务": "Failed tasks",
  "{{p0}} 个任务失败": "{{p0}} failed tasks",
  "清空失败": "Clear failed",
  "{{p0}} 个任务已完成": "{{p0}} completed tasks",
  "清空已完成": "Clear completed",
  "暂无下载任务": "No download tasks yet",
  "上传链接已复制": "Upload link copied",
  "创建上传链接失败": "Failed to create upload link",
  "上传失败": "Upload failed",
  "上传安全限制": "Upload security restriction",
  "上传成功": "Upload successful",
  "文件夹上传完成": "Folder upload complete",
  "成功上传 {{p0}} 个文件": "Successfully uploaded {{p0}} files",
  "文件夹上传完成（部分失败）": "Folder upload complete (some files failed)",
  "成功 {{p0}} 个，失败 {{p1}} 个": "{{p0}} succeeded, {{p1}} failed",
  "下载失败": "Download failed",
  "确定将选中的 {{p0}} 个项目移入回收站？": "Move the {{p0}} selected items to trash?",
  "已复制到剪贴板": "Copied to clipboard",
  "已剪切到剪贴板": "Cut to clipboard",
  "将 \"{{p0}}\" 移入回收站？": "Move \"{{p0}}\" to trash?",
  "已取消收藏": "Removed from starred",
  "已收藏": "Added to starred",
  "列表": "List",
  "网格": "Grid",
  "瀑布流": "Masonry",
  "松开上传（支持整个文件夹）": "Drop to upload (folders supported)",
  "文件管理": "Files",
  "管理您的文件与文件夹": "Manage your files and folders",
  "标签: {{p0}}": "Tag: {{p0}}",
  "搜索文件...": "Search files...",
  "高级搜索": "Advanced search",
  "搜索历史": "Search history",
  "清空": "Clear all",
  "语义搜索已开启": "Semantic search enabled",
  "开启语义搜索": "Enable semantic search",
  "语义": "Semantic",
  "关键词": "Keywords",
  "FTS5全文搜索已开启": "FTS5 full-text search enabled",
  "开启FTS5全文搜索": "Enable FTS5 full-text search",
  "普通": "Standard",
  "且": "AND",
  "或": "OR",
  "+ 添加条件": "+ Add condition",
  "清除": "Clear",
  "文件名": "Filename",
  "类型": "Type",
  "大小": "Size",
  "创建时间": "Created",
  "修改时间": "Modified",
  "标签": "Tags",
  "包含": "Contains",
  "等于": "Equals",
  "开头是": "Starts with",
  "结尾是": "Ends with",
  "大于": "Greater than",
  "小于": "Less than",
  "输入值...": "Enter a value...",
  "名称": "Name",
  "图库": "Gallery",
  "全选": "Select all",
  "刷新当前目录": "Refresh current folder",
  "显示全部文件": "Show all files",
  "只显示收藏文件": "Show starred files only",
  "全部": "All",
  "收藏": "Starred",
  "新建文件": "New file",
  "新建文件夹": "New folder",
  "上传文件": "Upload files",
  "上传文件夹": "Upload folder",
  "开始上传文件夹 \"{{p0}}\"": "Uploading folder \"{{p0}}\"",
  "{{p0}} 个文件夹，{{p1}} 个文件": "{{p0}} folders, {{p1}} files",
  "已选中 {{p0}} 个": "{{p0}} selected",
  "批量删除": "Delete selected",
  "版本已恢复": "Version restored",
  "标签管理": "Manage tags",
  "文件: {{p0}}": "File: {{p0}}",
  "关闭": "Close",
  "权限管理": "Permissions",
  "文件夹设置": "Folder settings",
  "文件夹: {{p0}}": "Folder: {{p0}}",
  "发送失败": "Failed to send",
  "请稍后重试": "Please try again later",
  "请输入邮箱": "Enter an email address",
  "请输入您的注册邮箱地址": "Enter the email address used to register",
  "邮件已发送": "Email sent",
  "如果邮箱存在，您将收到重置密码邮件": "If the email address exists, you will receive a password reset email",
  "请检查您的邮箱（包括垃圾邮件文件夹）": "Check your inbox (including the spam folder)",
  "邮件链接有效期为1小时": "The email link expires in 1 hour",
  "返回登录": "Back to sign in",
  "忘记密码": "Forgot password",
  "输入您的邮箱地址": "Enter your email address",
  "邮箱地址": "Email address",
  "我们将向您的注册邮箱发送密码重置链接": "We will send a password reset link to your registered email address",
  "发送中...": "Sending...",
  "发送重置邮件": "Send reset email",
  "登录失败": "Sign-in failed",
  "请检查邮箱和密码": "Check your email address and password",
  "验证失败": "Verification failed",
  "验证码无效": "Invalid verification code",
  "输入您的邮箱和密码登录系统": "Sign in with your email address and password",
  "邮箱": "Email",
  "密码": "Password",
  "忘记密码？": "Forgot password?",
  "两步验证码": "Two-step verification code",
  "6 位验证码或备用码": "6-digit code or recovery code",
  "在本次登录有效期内信任此设备": "Trust this device for the duration of this sign-in session",
  "登录中...": "Signing in...",
  "验证中...": "Verifying...",
  "验证并登录": "Verify and sign in",
  "还没有账号？{{p0}}": "No account yet?{{p0}}",
  "立即注册": "Register now",
  "授权管理": "Access management",
  "用户组": "Groups",
  "管理用户组、授权、Webhook 和 API Key": "Manage groups, permissions, webhooks, and API keys",
  "权限说明": "Permission guide",
  "API 文档": "API documentation",
  "注册失败": "Registration failed",
  "请检查输入信息": "Check your input",
  "密码不匹配": "Passwords do not match",
  "请确保两次输入的密码一致": "Make sure both passwords are the same",
  "注册已关闭": "Registration closed",
  "当前系统不开放新用户注册，请联系管理员获取访问权限。": "New user registration is disabled. Contact the administrator for access.",
  "创建一个新账号开始使用": "Create a new account to get started",
  "昵称（可选）": "Nickname (optional)",
  "您的昵称": "Your nickname",
  "至少6个字符": "At least 6 characters",
  "确认密码": "Confirm password",
  "再次输入密码": "Enter your password again",
  "邀请码": "Invitation code",
  "（必填）": "(required)",
  "此系统需要邀请码才能注册，请向管理员获取": "An invitation code is required to register. Ask the administrator for one.",
  "邀请码无效或已过期，请检查后重试": "This invitation code is invalid or expired. Check it and try again.",
  "邀请码已被使用，请使用其他邀请码": "This invitation code has already been used. Use a different code.",
  "我有邀请码": "I have an invitation code",
  "注册中...": "Registering...",
  "已有账号？{{p0}}": "Already have an account?{{p0}}",
  "立即登录": "Sign in now",
  "无效链接": "Invalid link",
  "缺少重置Token，请重新申请": "Reset token is missing. Request a new reset link.",
  "密码重置成功": "Password reset successful",
  "请使用新密码登录": "Sign in with your new password",
  "重置失败": "Reset failed",
  "请重试": "Please try again",
  "密码格式错误": "Invalid password format",
  "密码至少需要6个字符": "Password must contain at least 6 characters",
  "两次输入的密码不一致": "The passwords do not match",
  "弱": "Weak",
  "中": "Medium",
  "强": "Strong",
  "重置密码": "Reset password",
  "设置您的新密码": "Set your new password",
  "密码强度：{{p0}}": "Password strength: {{p0}}",
  "再次输入新密码": "Enter your new password again",
  "密码一致": "Passwords match",
  "重置中...": "Resetting...",
  "浏览器": "Browser",
  "未知系统": "Unknown system",
  "确认邮件已发送": "Confirmation email sent",
  "请查收新邮箱并点击确认链接": "Check the new email inbox and click the confirmation link",
  "请检查输入": "Check your input",
  "请填写完整信息": "Complete all required fields",
  "新邮箱地址": "New email address",
  "当前密码": "Current password",
  "发送确认邮件": "Send confirmation email",
  "偏好已保存": "Preferences saved",
  "保存失败": "Save failed",
  "加载中...": "Loading...",
  "登录成功通知": "Successful sign-in notifications",
  "登录成功时发送邮件，默认开启": "Email on successful sign-in; enabled by default",
  "登录失败通知": "Failed sign-in notifications",
  "密码或两步验证失败、账户锁定时通知，同一账户5分钟内最多一封，默认开启": "Notify on password or two-step verification failure and account lockout, up to one email per account every 5 minutes; enabled by default",
  "@提及通知": "@mention notifications",
  "当有人在文件或评论中@您时发送邮件": "Email when someone @mentions you in a file or comment",
  "分享接收通知": "Share notifications",
  "当他人分享文件给您时发送邮件": "Email when someone shares a file with you",
  "配额警告": "Quota warnings",
  "存储空间即将用尽时发送警告邮件": "Email when storage is nearly full",
  "AI处理完成": "AI processing complete",
  "AI摘要或标签处理完成时发送邮件": "Email when AI summaries or tags finish processing",
  "系统通知": "System notifications",
  "重要的系统更新和安全提醒": "Important system updates and security alerts",
  "无法开始设置": "Unable to start setup",
  "两步验证已开启": "Two-step verification enabled",
  "开启失败": "Failed to enable",
  "两步验证已关闭": "Two-step verification disabled",
  "关闭失败": "Failed to disable",
  "备用恢复码已重新生成": "Recovery codes regenerated",
  "信任设备已撤销": "Trusted device revoked",
  "两步验证": "Two-step verification",
  "使用一次性验证码保护登录": "Protect sign-in with one-time verification codes",
  "已开启": "Enabled",
  "未开启": "Not enabled",
  "TOTP 验证码每 30 秒刷新": "TOTP codes refresh every 30 seconds",
  "更换验证器": "Change authenticator",
  "开始设置": "Start setup",
  "旧验证器验证码或恢复码（更换前验证）": "Current authenticator code or recovery code (verify before changing)",
  "当前密码（首次启用前验证）": "Current password (verify before first-time setup)",
  "设置两步验证前再次验证身份": "Verify your identity again before setting up two-step verification",
  "密钥": "Secret key",
  "密钥已复制": "Secret key copied",
  "验证器 URI 已复制": "Authenticator URI copied",
  "复制验证器 URI": "Copy authenticator URI",
  "6 位验证码": "6-digit verification code",
  "确认更换": "Confirm change",
  "开启": "Enable",
  "备用恢复码": "Recovery codes",
  "验证码或备用码": "Verification code or recovery code",
  "生成中...": "Generating...",
  "重新生成": "Regenerate",
  "信任设备": "Trusted devices",
  "信任凭据仅在关联登录会话有效期内生效，退出或撤销设备后立即失效": "Trust credentials are only valid during the linked sign-in session and expire immediately when you sign out or revoke a device",
  "暂无信任设备": "No trusted devices",
  "未命名设备": "Unnamed device",
  "最近使用 {{p0}} · 过期 {{p1}}": "Last used {{p0}} · Expires {{p1}}",
  "撤销": "Revoke",
  "关闭中...": "Disabling...",
  "请保存这些恢复码": "Save these recovery codes",
  "恢复码已复制": "Recovery codes copied",
  "复制全部": "Copy all",
  "昵称已更新": "Nickname updated",
  "密码已更新，请重新登录": "Password updated. Sign in again.",
  "修改密码失败": "Failed to change password",
  "账户已注销": "Account deleted",
  "注销失败": "Account deletion failed",
  "设备已注销": "Device signed out",
  "个人信息": "Profile",
  "邮箱设置": "Email settings",
  "安全设置": "Security",
  "AI 功能": "AI features",
  "设置": "Settings",
  "管理您的账户与偏好": "Manage your account and preferences",
  "更新您的显示名称": "Update your display name",
  "输入昵称（留空则使用邮箱）": "Enter a nickname (leave blank to use your email address)",
  "保存中…": "Saving...",
  "注册于": "Registered",
  "您当前的存储使用情况": "Your current storage usage",
  "总配额": "Total quota",
  "WebDAV 访问": "WebDAV access",
  "使用 WebDAV 客户端挂载文件系统": "Mount the filesystem with a WebDAV client",
  "WebDAV 地址": "WebDAV URL",
  "已复制 WebDAV 地址": "WebDAV URL copied",
  "用户名": "Username",
  "已复制邮箱": "Email address copied",
  "使用独立应用凭据；登录密码仅适用于未启用两步验证的账户": "Use dedicated app credentials; your sign-in password only works for accounts without two-step verification",
  "支持 macOS Finder、Windows 资源管理器、Cyberduck、Mountain Duck 等客户端": "Supports macOS Finder, Windows File Explorer, Cyberduck, Mountain Duck, and other clients",
  "管理您的邮箱地址和通知偏好": "Manage your email address and notification preferences",
  "当前邮箱": "Current email address",
  "已验证": "Verified",
  "未验证": "Unverified",
  "您的邮箱尚未验证，部分功能受限。": "Your email address is not verified. Some features are restricted.",
  "验证邮件已发送": "Verification email sent",
  "重发验证邮件": "Resend verification email",
  "更换邮箱": "Change email address",
  "更换邮箱后需要重新验证，新邮箱将作为登录账号": "The new email address must be verified and becomes your sign-in account",
  "邮件通知偏好": "Email notification preferences",
  "选择您希望接收的邮件通知类型": "Choose the email notifications you want to receive",
  "临时安全限制": "Temporary security restrictions",
  "账户安全操作仅支持登录会话。创建/扩大 API Key 权限和更换两步验证需再次验证身份；可信设备使用独立凭据，不按 IP/设备信息跳过验证。启用两步验证后，WebDAV 使用独立应用凭据。": "Account security operations require a sign-in session. Creating or expanding API key permissions and changing two-step verification require identity verification. Trusted devices use dedicated credentials and do not bypass verification based on IP or device information. With two-step verification enabled, WebDAV uses dedicated app credentials.",
  "任意 URL 离线下载、Webhook 投递/测试和未经批准的自定义存储或机器人端点访问已暂停，等待安全目标策略就绪。": "Offline downloads from arbitrary URLs, webhook delivery/testing, and access to unapproved custom storage or bot endpoints are paused until security destination policies are ready.",
  "新上传支持基于服务端凭据的单次直传和分片上传；仅在存储不支持直传或 PUT 失败时回退代理完整上传。旧分片任务不能续传或复用，请在文件列表重新选择原文件完整上传。含账户令牌的文件链接不能外发。HTML/SVG 仅允许附件下载；Office 禁用嵌入 HTML，表格仅显示值。离线缓存仅保留公共静态资源。": "New uploads support server-authorized one-time direct and multipart uploads, falling back to a full proxy upload only if direct uploads are unsupported or PUT fails. Legacy multipart tasks cannot be resumed or reused; select the original file in the file list and upload it again in full. Do not share file links containing account tokens. HTML/SVG files are download-only attachments; embedded HTML is disabled in Office previews, and spreadsheets show values only. Offline caches retain only public static resources.",
  "修改密码": "Change password",
  "定期更换密码以保证账户安全": "Change your password regularly to protect your account",
  "输入当前密码": "Enter your current password",
  "至少 6 个字符": "At least 6 characters",
  "确认新密码": "Confirm new password",
  "更新中…": "Updating...",
  "更新密码": "Update password",
  "登录设备": "Signed-in devices",
  "管理已登录的设备": "Manage devices signed in to your account",
  "暂无已登录设备": "No signed-in devices",
  "当前设备": "Current device",
  "确定要注销此设备吗？": "Sign out this device?",
  "注销": "Sign out",
  "如果发现陌生设备登录，请立即修改密码并注销该设备": "If you see an unfamiliar device, change your password immediately and sign out that device",
  "危险区域": "Danger zone",
  "不可撤销的操作，请谨慎": "Irreversible actions; proceed with caution",
  "注销账户": "Delete account",
  "永久删除账户及所有文件，此操作不可撤销": "Permanently delete your account and all files. This cannot be undone.",
  "此操作将永久删除您的账户、所有文件和分享链接，且不可恢复。请输入密码确认。": "This permanently deletes your account, all files, and share links. This cannot be undone. Enter your password to confirm.",
  "输入密码确认注销": "Enter your password to confirm deletion",
  "注销中…": "Deleting...",
  "确认永久注销": "Confirm permanent deletion",
  "Powered by OSSshelf · 多厂商 OSS 文件管理系统": "Powered by OSSshelf · Multi-provider object storage file manager",
  "需要访问密码": "Access password required",
  "该内容已加密，请输入密码继续": "This content is protected. Enter the password to continue.",
  "输入访问密码": "Enter access password",
  "密码错误，请重试": "Incorrect password. Try again.",
  "验证密码": "Verify password",
  "文件分享": "File share",
  "链接已过期": "Link expired",
  "这个分享链接已超过有效期，无法访问。": "This share link has expired and is no longer accessible.",
  "下载次数已达上限": "Download limit reached",
  "该分享链接的下载次数已用完。": "This share link has no downloads remaining.",
  "预览": "Preview",
  "{{p0}} 个项目": "{{p0}} items",
  "取消全选": "Deselect all",
  "（已选 {{p0}}）": "({{p0}} selected)",
  "下载所选 ({{p0}})": "Download selected ({{p0}})",
  "全部 ZIP": "Download all as ZIP",
  "文件夹为空": "This folder is empty",
  "过期 {{p0}}": "Expires {{p0}}",
  "剩余 {{p0}} 次": "{{p0}} downloads remaining",
  "已加密": "Password protected",
  "这个上传链接已超过有效期，无法访问。": "This upload link has expired and is no longer accessible.",
  "上传到：{{p0}}": "Upload to: {{p0}}",
  "最大 {{p0}}": "Maximum {{p0}}",
  "限 {{p0}}": "Limit {{p0}}",
  "点击或拖放文件到此处": "Click or drop files here",
  "支持多文件同时上传": "Upload multiple files at once",
  "尚未选择文件": "No files selected",
  "{{p0}} 个已完成": "{{p0}} completed",
  "{{p0}}{{p1}} 个待上传": "{{p0}}{{p1}} pending uploads",
  "上传中...": "Uploading...",
  "开始上传": "Start upload",
  "直链已删除": "Direct link deleted",
  "删除直链失败": "Failed to delete direct link",
  "已删除": "Deleted",
  "链接已复制到剪贴板": "Link copied to clipboard",
  "分享管理": "Shares",
  "个有效下载分享 ·": "active download shares ·",
  "个有效上传链接": "active upload links",
  "直链加载失败": "Failed to load direct links",
  "{{p0}} 个有效直链": "{{p0}} active direct links",
  "下载分享": "Download shares",
  "直链分享": "Direct links",
  "上传链接": "Upload links",
  "暂无下载分享": "No download shares yet",
  "在文件管理页面右键文件即可创建": "Right-click a file on the Files page to create a share",
  "确定要删除这个分享链接吗？": "Delete this share link?",
  "删除 {{p0}} 个失效链接？": "Delete {{p0}} inactive links?",
  "暂无直链分享": "No direct links yet",
  "在文件管理页面右键文件，选择「直链」即可创建": "Right-click a file on the Files page and select \"Direct link\"",
  "直链已复制到剪贴板": "Direct link copied to clipboard",
  "复制失败，请重试": "Failed to copy. Try again.",
  "确定要删除这个直链吗？原链接将立即失效。": "Delete this direct link? It will stop working immediately.",
  "删除 {{p0}} 个失效直链？": "Delete {{p0}} inactive direct links?",
  "创建上传链接": "Create upload link",
  "暂无上传链接": "No upload links yet",
  "创建上传链接后，任何人无需登录即可上传文件到指定文件夹": "Anyone can use an upload link to upload files to the specified folder without signing in",
  "确定要删除这个上传链接吗？": "Delete this upload link?",
  "选择目标文件夹": "Select target folder",
  "下一步：设置链接": "Next: link settings",
  "有效": "Active",
  "已失效": "Inactive",
  "清理失效": "Clear inactive",
  "已过期": "Expired",
  "次数已满": "Limit reached",
  "未知文件夹": "Unknown folder",
  "创建 {{p0}}": "Created {{p0}}",
  "永久有效": "Never expires",
  "已过期于": "Expired on",
  "过期": "Expires",
  "有密码": "Password protected",
  "{{p0}} / {{p1}} 次": "{{p0}} / {{p1}} downloads",
  "复制链接": "Copy link",
  "在新标签页打开": "Open in new tab",
  "{{p0}} 个收藏文件": "{{p0}} starred files",
  "暂无收藏文件": "No starred files yet",
  "在文件列表中点击 ☆ 即可收藏": "Click the star in the file list to add a file to starred",
  "上传中": "Uploading",
  "已取消": "Canceled",
  "今天": "Today",
  "昨天": "Yesterday",
  "最近7天": "Last 7 days",
  "最近30天": "Last 30 days",
  "更早": "Earlier",
  "任务已取消": "Task canceled",
  "取消失败": "Cancellation failed",
  "已清空已完成的任务": "Completed tasks cleared",
  "已清空失败/过期/取消的任务": "Failed, expired, and canceled tasks cleared",
  "任务已暂停": "Task paused",
  "暂停失败": "Pause failed",
  "任务已恢复": "Task resumed",
  "任务已重置，请重新选择文件上传": "Task reset. Select the file again to upload.",
  "{{p0}} 个任务暂停失败": "Failed to pause {{p0}} tasks",
  "已暂停 {{p0}} 个任务": "Paused {{p0}} tasks",
  "批量暂停失败": "Batch pause failed",
  "{{p0}} 个任务删除失败": "Failed to delete {{p0}} tasks",
  "已删除 {{p0}} 个暂停的任务": "Deleted {{p0}} paused tasks",
  "批量删除失败": "Batch deletion failed",
  "暂不支持续传": "Resuming is not currently supported",
  "任务不存在": "Task not found",
  "文件大小不匹配": "File size does not match",
  "请选择相同大小的文件（{{p0}}）": "Select a file of the same size ({{p0}})",
  "文件名不匹配": "Filename does not match",
  "请选择名为 \"{{p0}}\" 的文件": "Select the file named \"{{p0}}\"",
  "正在恢复上传...": "Resuming upload...",
  "请勿关闭此页面": "Do not close this page",
  "上传进度: {{p0}}%": "Upload progress: {{p0}}%",
  "上传完成": "Upload complete",
  "未知错误": "Unknown error",
  "上传任务": "Upload tasks",
  "管理文件上传任务": "Manage file upload tasks",
  "{{p0}} 新上传支持基于服务端凭据的单次直传和分片上传；仅在存储不支持直传或 PUT 失败时回退代理完整上传。上传进度请在文件列表查看。旧任务不可复用，暂停、恢复、重试和终止操作暂不可用。": "{{p0}} New uploads support server-authorized one-time direct and multipart uploads, falling back to a full proxy upload only if direct uploads are unsupported or PUT fails. View upload progress on the Files page. Legacy tasks cannot be reused; pause, resume, retry, and cancel operations are currently unavailable.",
  "一键暂停 ({{p0}})": "Pause all ({{p0}})",
  "删除暂停中 ({{p0}})": "Delete paused ({{p0}})",
  "历史任务": "Task history",
  "{{p0}} 个已完成或失败的任务": "{{p0}} completed or failed tasks",
  "暂无上传任务": "No upload tasks yet",
  "上传文件时会自动创建任务": "Tasks are created automatically when you upload files",
  "{{p0}} / {{p1}} 分片": "{{p0}} / {{p1}} chunks",
  "继续上传": "Continue upload",
  "已恢复文件": "File restored",
  "已永久删除": "Permanently deleted",
  "已清空回收站": "Trash emptied",
  "确定要永久删除回收站中所有 {{p0}} 个文件吗？此操作不可撤销。": "Permanently delete all {{p0}} files in trash? This cannot be undone.",
  "{{p0}} 个文件等待清理": "{{p0}} files awaiting cleanup",
  "回收站是空的": "Trash is empty",
  "清空回收站": "Empty trash",
  "回收站中的文件不占用您的存储配额，但在永久删除前仍保留在服务器上。": "Files in trash do not count toward your storage quota, but remain on the server until permanently deleted.",
  "删除的文件会出现在这里": "Deleted files appear here",
  "永久删除 \"{{p0}}\"？此操作不可撤销。": "Permanently delete \"{{p0}}\"? This cannot be undone.",
  "· 删除于 {{p0}}": "· Deleted {{p0}}",
  "永久删除": "Delete permanently",
  "缺少验证Token": "Verification token is missing",
  "邮箱验证成功！": "Email verified successfully!",
  "验证失败，请重试": "Verification failed. Try again.",
  "正在验证邮箱...": "Verifying email...",
  "验证成功": "Verification successful"
};
